export const CREATE_ENGAGEMENTS_COMMENT_REQUEST = 'CREATE_ENGAGEMENTS_COMMENT_REQUEST';
export const CREATE_ENGAGEMENTS_COMMENT_SUCCESS = 'CREATE_ENGAGEMENTS_COMMENT_SUCCESS';
export const CREATE_ENGAGEMENTS_COMMENT_FAILURE = 'CREATE_ENGAGEMENTS_COMMENT_FAILURE';
